import * as React from 'react';
import { Context as ReactContext } from 'react';
import type { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { Context } from '@micro-frontend-react/core/lib/Context';

import { PBTApiEndpoints } from '../PBTConstants';
import { PBTEngagementModel } from '../../Interfaces/IPBTCase';

export function useBypassManager(onSuccess?: () => void) {
  const { authClient } = React.useContext(Context as ReactContext<IEmployeeExperienceContext>);

  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const bypassManager = React.useCallback(async (caseId: number) => {
    setIsSubmitting(true);
    setError(null);

    try {
      const token = await authClient.acquireToken(__SCOPES__);
      const response = await fetch(PBTApiEndpoints.UpdateEngagementModel(caseId), {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ engagementModel: PBTEngagementModel.HRCLed }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        setError(errorData?.error?.message || 'Failed to update engagement model.');
        return false;
      }

      onSuccess?.();
      return true;
    } catch {
      setError('Something went wrong while updating the engagement model.');
      return false;
    } finally {
      setIsSubmitting(false);
    }
  }, [authClient, onSuccess]);

  return { bypassManager, isSubmitting, error };
}
